<template>
  <section id="file" class="slideDown">
    <div class="back" @click="back()">{{ $t('general.return') }}</div>

    <div :class="{ show: prev }" class="overlay" @click.self="prev = false">
      <div class="popup">
        <img
          @click="prev = true"
          :src="file.thumb + '?' + date(file.update_date)"
        />
      </div>
    </div>

    <div class="container">
      <div class="image">
        <img
          @click="prev = true"
          :src="file.thumb + '?' + date(file.update_date)"
        />
      </div>
      <div class="content">
        <h3 class="title">{{ file.name }}</h3>
        <span class="description" v-html="file.description"></span>

        <div class="details">
          <div class="subtitle">{{ $t('general.details') }}</div>

          <div
            v-if="file.reference != null && file.reference != ''"
            class="item"
          >
            <span class="label">{{ $t('general.reference_abbreviation') }}</span>
            <span class="value">{{ file.reference }}</span>
          </div>

          <div class="item">
            <span class="label">{{ $t('general.piece') }}</span>
            <span class="value">{{ file.type.name }}</span>
          </div>

          <div class="item" v-if="lang != 'Português'">
            <span class="label">{{ $t('general.language') }}: </span>
            <span class="value">{{ lang }}</span>
          </div>
        </div>

        <div class="buttons">
          <a
            :href="downloadUrl"
            class="bttn download"
            target="_blank"
            v-if="file.file != '' && file.download != 0 && file.status != 2"
            @click="logToolkit"
          >
            <div class="icon"></div>
            <span>{{ $t('general.download') }}</span>
          </a>
          <div v-if="isDocumentType && file.status == 2" class="bttn soon">
            <div class="icon"></div>
            <span>{{ $t('general.soon') }}</span>
          </div>
          <div
            v-if="file.file != '' && !isDocumentType"
            @click="order(file.id)"
            class="bttn order"
          >
            <div class="icon"></div>
            <span>{{ $t('files.file.adaptation') }}</span>
          </div>
          <div
            v-if="file.budget == 1 && !isDocumentType"
            v-on:click.stop
            @click="cart(file)"
            class="bttn production"
          >
            <div class="icon"></div>
            <span>{{ $t('files.file.budget_production') }}</span>
          </div>
        </div>
        <template v-if="file.file != ''">
          <span class="desc">{{ $t('files.file.url') }}</span>
          <div v-show="copy_message" class="message success fadeIn">
            {{ $t('files.file.url_copied') }}
          </div>
          <input
            @focus="copy()"
            readonly
            class="url"
            type="text"
            name="url"
            v-model="file_url"
            id="txt_to_copy"
          />
        </template>
      </div>
    </div>
    <iframe
      v-if="showPdfPreview"
      class="pdf-viewer"
      :src="file.file"
      width="100%"
      height="100%"
    ></iframe>
  </section>
</template>

<script>
export default {
  props: { file: Object, type: Number },
  data() {
    return {
      copy_message: false,
      domain_url: window.location.origin + "/r/",
      prev: false
    };
  },
  created() {
    const category = this.$store.getters["files/getCurrentCategory"];
    const currentFile = this.$store.getters["files/getCurrentFile"];
    if (category && category.url && currentFile && currentFile.url) {
      this.$router.push({
        name: this.path + "_category_resource",
        params: {
          category: category.url,
          resource: currentFile.url
        }
      });
    }
  },
  computed: {
    path() {
      if (this.type == 1) return "nacional";
      if (this.type == 2) return "local";
      if (this.type == 3) return "comunicacion";
      if (this.type == 4) return "toolkits";
      if (this.type == 5) return "practices";
      return "nacional";
    },
    isDocumentType() {
      return this.type == 4 || this.type == 5;
    },
    isPdf() {
      return (
        this.file &&
        this.file.file &&
        /\.pdf(\?|#|$)/i.test(this.file.file)
      );
    },
    showPdfPreview() {
      return this.isDocumentType && this.isPdf;
    },
    downloadUrl() {
      if (this.isDocumentType) {
        return this.file.file;
      }
      return this.domain_url + this.file.id + "/" + this.user_id;
    },
    file_url() {
      return this.domain_url + this.file.id;
    },
    user_id() {
      var data = this.$store.getters["user/getUser"];
      return data.id;
    },
    lang() {
      var languages = this.$store.state.languages;
      for (var k in languages) {
        if (languages[k].id == this.file.lang.id) return languages[k].fullname;
      }
      return false;
    },
    not_admin() {
      return !this.$store.getters["user/isAdmin"];
    }
  },
  methods: {
    back() {
      this.$store.commit("files/setCurrentFile", false);
      const category = this.$store.getters["files/getCurrentCategory"];
      if (category && category.url) {
        this.$router.push({
          name: this.path + "_category",
          params: {
            category: category.url
          }
        });
      } else {
        this.$router.push({ name: this.path });
      }
    },
    logToolkit() {
      if (this.type == 4) {
        this.$store.dispatch("files/logToolkit", {
          resource_id: this.file.id,
          user_id: this.user_id
        });
      }
    },
    copy() {
      let toCopy = document.querySelector("#txt_to_copy");
      toCopy.select();

      try {
        var successful = document.execCommand("copy");
        this.copy_message = true;
        var self = this;
        setTimeout(function() {
          self.copy_message = false;
        }, 3000);
      } catch (err) {}
    },
    order(id) {
      this.$router.push("/order/" + id);
    },
    cart(item) {
      var order = {
        from: { file: item.id, filename: item.name, image: item.thumb },
        to: { file: false, filename: false, size: "" },
        method: 2,
        units: false,
        billed: false,
        shipped: false,
        custom_ship: "",
        custom: "",
        custom_file: null,
        params: {}
      };

      this.$store.commit("orders/addOrderToCart", order);
      this.$store.commit("files/unsetCurrentFile");
      this.$router.push({ name: "cart" });
    },
    date(date) {
      return moment(date).valueOf();
    }
  },
  destroy() {
    alert("destroy");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#file {
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
}

.back {
  background: url(/img/left-arrow.svg) no-repeat left center;
  text-align: left;
  margin-bottom: 20px;
  padding-left: 25px;
  cursor: pointer;
}
.container {
  width: 100%;
  overflow: hidden;

  .image {
    width: 40%;
    float: left;
    padding: 0 40px;

    img {
      width: 95%;
      cursor: pointer;
    }
  }

  .content {
    width: 60%;
    float: left;
    text-align: left;
    padding: 0 25px;

    .title {
      margin: 10px 0;
      font-size: 20pt;
      font-family: Speedee-Bold;
    }

    .description {
      white-space: pre;
    }
    .details {
      margin: 20px 0;

      .subtitle {
        font-family: Speedee-Bold;
        color: #bbb;
        margin-bottom: 10px;
      }
      .item {
        font-size: 11pt;

        .label {
          margin-right: 5px;
        }
        .value {
          font-family: Speedee-Bold;
        }
      }
    }

    .buttons {
      margin: 35px 0;

      .bttn {
        width: 100%;
        max-width: 300px;
        overflow: hidden;
        margin-bottom: 5px;
        line-height: 30px;
        cursor: pointer;
        display: block;
        color: #333;

        .icon {
          width: 30px;
          height: 30px;
          background: #ccc;
          display: inline-block;
          float: left;
          overflow: hidden;
        }
        span {
          display: inline-block;
          float: left;
          padding-left: 5px;
          font-size: 11pt;

          &:hover {
            font-family: Speedee-Bold;
          }
        }
        &.download {
          border-top: 2px solid var(--main_color);

          .icon {
            background: url(/img/download.svg) no-repeat center
              var(--main_color);
            background-size: 18px;
          }
        }
        &.order {
          border-top: 2px solid #ccc;
          .icon {
            background: url(/img/edit.svg) no-repeat center #ccc;
            background-size: 18px;
          }
        }
        &.production {
          border-top: 2px solid #ccc;
          .icon {
            background: url(/img/box.svg) no-repeat center #ccc;
            background-size: 18px;
          }
        }
        &.soon {
          border-top: 2px solid #ccc;
          cursor: auto;
          .icon {
            background: #ccc;
          }
        }
      }
    }
    .desc {
      font-size: 10pt;
      margin-top: 25px;
      margin-bottom: 5px;
      display: block;
    }
    .url {
      width: 100%;
      padding: 5px;
      font-size: 11pt;
      border-radius: 5px;
      border: 1px solid #ccc;
    }
  }
}

.pdf-viewer {
  width: 100%;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 4px;
  height: 70vh;
  margin: 20px auto;
  display: block;
}

.overlay {
  display: none;
  position: fixed;
  z-index: 10;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  transition: opacity 500ms;
  visibility: hidden;
  opacity: 0;

  &.show {
    display: unset;
    visibility: visible;
    opacity: 1;
  }

  .popup {
    visibility: visible;
    display: inline-flex;
    margin-top: 5vh;

    img {
      max-height: 90vh;
    }
  }
}
</style>
